module.exports = __webpack_public_path__ + "static/media-query-syntax-68dbae4d9360a0a6cbf2c2799fd64e18.png";